// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Tracker from "./components/Tracker";

const React = require("react");
import {createRoot} from 'react-dom/client';

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import NiceModal from '@ebay/nice-modal-react';
import "antd-mobile/es/global"
import _ from "lodash";

window._ = _;

Bugsnag.start({
    apiKey: '7e71ab9984bb6ea4538ba94377e42a8d',
    enabledReleaseStages: ['production', 'staging'],
    plugins: [new BugsnagPluginReact()]
});

Tracker.init();

const ErrorBoundary = Bugsnag.getPlugin('react')
    .createErrorBoundary(React)

export const loader = (app) => {
    let root = createRoot(document.getElementById('root'));
    root.render(
        <ErrorBoundary>
            <NiceModal.Provider>
                {app}
            </NiceModal.Provider>
        </ErrorBoundary>
    );
}

